import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useSignalRListener } from '@/components/Hooks/useSignalRListener';
import { useTabTitleNotifier } from '@/components/Hooks/useTabTitleNotifier';
import { SIGNALR_MESSAGE_TYPES } from '@/constants/signalrMessageTypes';
import { playSound } from '@/helpers/audioHelper';
import { getCurrentUser } from '@/helpers/session_helper';

import './assets/scss/themes.scss';
import Route from './routes';

function App() {
  const { notifyTabTitle } = useTabTitleNotifier();

  const notify = (message) => {
    const isLoggedIn = getCurrentUser();
    if (!isLoggedIn) return;

    playSound();

    notifyTabTitle();

    toast(
      <p
        style={{ position: "relative", zIndex: 10, cursor: "pointer" }}
        dangerouslySetInnerHTML={{
          __html: message,
        }}
      />,
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        className: "bg-success text-white",
      }
    );
  };

  useSignalRListener({
    type: SIGNALR_MESSAGE_TYPES.NOTIFICATION,
    handler: notify,
  });

  return (
    <>
      <ToastContainer />
      <Route />
    </>
  );
}

export default App;
